export default "__VITE_ASSET__oA4Auobz__"